import { FC, useEffect, useState } from 'react';
import {
    camW,
    checkW,
    errorIcon,
    errorW,
    home,
    prize,
    prizeGray,
    prizeWhite,
    red as rI,
    watch,
    watchW,
} from '../../assets';
import { useTranslation } from 'react-i18next';
import { message } from 'antd';
import { GiftShop_Info } from '../../generated/mlmbox/types/gift_shop';
import { getCard } from '../../shared/api/market';
import { Status_Transaction } from '../../generated/mlmbox/types/status';
import Loader from '../../shared/ui/Loader/Loader';
import MessageStick from '../../shared/ui/MessageStick/MessageStick';
import MenuItem from '../../shared/ui/MenuItem/MenuItem';
import { useNavigate, useParams } from 'react-router';
import styles from './CardFromMarket.module.scss';
import PageHeader from '../../shared/ui/PageHeader/PageHeader';
import ShodawButton from '../../shared/ui/ShadowButton/ShodawButton';

interface IMarketCardProps {
    // cardId: number;
    // close: () => void;
}

const CardFromMarket: FC<IMarketCardProps> = () => {
    const { cardId } = useParams();
    const [cardInfo, setCardInfo] = useState<GiftShop_Info>();
    const [picture, setPicture] = useState<string>();
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!cardId) return;
        getCard(Number(cardId))
            .then((res) => {
                if (res) setCardInfo(res);
            })
            .catch((e) => {
                console.log(e);
            });
    }, []);

    function done() {
        if (!cardInfo) return false;
        return (
            Math.round(Number((100 * Number(cardInfo.pointsBalanceAvailable)) / Number(cardInfo.card?.pointsNeeded))) >=
                100 &&
            cardInfo.card &&
            !cardInfo.card.released
        );
    }

    function wait() {
        if (!cardInfo) return false;
        return (
            cardInfo.card &&
            cardInfo.card.released &&
            cardInfo.card.transaction?.statusId !== Status_Transaction.SUCCESS
        );
    }

    function rew() {
        if (!cardInfo) return false;
        return (
            cardInfo.card &&
            cardInfo.card.released &&
            cardInfo.card.transaction?.statusId === Status_Transaction.SUCCESS &&
            !cardInfo.card.reviewVideoUrl
        );
    }

    function a() {
        if (!cardInfo) return false;
        return (
            cardInfo.card &&
            cardInfo.card.released &&
            cardInfo.card.transaction?.statusId === Status_Transaction.SUCCESS &&
            cardInfo.card.reviewVideoUrl &&
            cardInfo.card.reviewApproved
        );
    }

    return (
        <>
            <div className={styles.cardFromMarket}>
                {cardInfo && (
                    <div className="start">
                        <PageHeader
                            title={t('card_header')}
                            closeBtn={() => navigate('/market')}
                        />

                        <>
                            <div className={styles.img}>
                                <div
                                    className={styles.content}
                                    style={{ display: !picture ? 'none' : 'flex' }}>
                                    <span
                                        style={{
                                            backgroundImage: `url(${import.meta.env.VITE_API_URL}/${
                                                cardInfo?.card?.imageSrc
                                            })`,
                                        }}></span>
                                    <img
                                        onLoad={() => {
                                            setPicture(`${import.meta.env.VITE_API_URL}/${cardInfo?.card?.imageSrc}`);
                                        }}
                                        src={`${import.meta.env.VITE_API_URL}/${cardInfo?.card?.imageSrc}`}
                                        alt=""
                                    />
                                    {!cardInfo.card?.released && (
                                        <div
                                            className={styles.red}
                                            onClick={() => cardInfo?.card && navigate(`/edit/${cardInfo.card.id}`)}>
                                            <img
                                                className={styles.redImg}
                                                src={rI}
                                                alt=""
                                            />
                                        </div>
                                    )}
                                </div>
                                {!picture && (
                                    <div className="load-market">
                                        <Loader />
                                    </div>
                                )}
                            </div>

                            <div className={styles.title}>
                                <h1>{cardInfo.card?.title}</h1>
                                <p
                                    style={{
                                        color:
                                            Number(cardInfo.pointsBalanceAvailable) >=
                                            Number(cardInfo.card?.pointsNeeded)
                                                ? '#2FF87F'
                                                : '#8993A7',
                                    }}>
                                    <img
                                        src={
                                            Number(cardInfo.pointsBalanceAvailable) >=
                                            Number(cardInfo.card?.pointsNeeded)
                                                ? prize
                                                : prizeGray
                                        }
                                        alt=""
                                    />
                                    {Number(cardInfo.card?.pointsNeeded).toLocaleString()}
                                </p>
                            </div>
                            <div
                                style={{ margin: '18px 0' }}
                                className="l2"></div>
                            <div className={styles.description}>
                                <h2>{t('desc')}</h2>
                                <p>{cardInfo.card?.description}</p>
                            </div>

                            {cardInfo.card && cardInfo.card.transaction && (
                                <>
                                    {' '}
                                    <div
                                        style={{ margin: '18px 0' }}
                                        className="l2"></div>
                                    <div className={styles.withd}>
                                        <h1>
                                            {t('withdraw')}
                                            <MessageStick
                                                style={{
                                                    gap: '5px',
                                                    padding: '6px',
                                                    height: '26px',
                                                    width: 'fit-content',
                                                    borderRadius: '5px',
                                                }}
                                                icon={
                                                    cardInfo.card &&
                                                    cardInfo.card.transaction.statusId === Status_Transaction.PROCESSING
                                                        ? watchW
                                                        : cardInfo.card.transaction.statusId ===
                                                          Status_Transaction.SUCCESS
                                                        ? checkW
                                                        : errorW
                                                }
                                                title={
                                                    cardInfo.card &&
                                                    cardInfo.card.transaction.statusId === Status_Transaction.PROCESSING
                                                        ? t('pro')
                                                        : cardInfo.card.transaction.statusId ===
                                                          Status_Transaction.SUCCESS
                                                        ? t('done')
                                                        : t('er')
                                                }
                                                bg={
                                                    cardInfo.card &&
                                                    cardInfo.card.transaction.statusId === Status_Transaction.PROCESSING
                                                        ? 'rgba(255, 163, 78, 0.15)'
                                                        : cardInfo.card.transaction.statusId ===
                                                          Status_Transaction.SUCCESS
                                                        ? 'rgba(47, 248, 127, 0.15)'
                                                        : 'rgba(255, 78, 99, 0.15)'
                                                }
                                            />
                                        </h1>

                                        {cardInfo.card.transaction.metadata?.uniqueField.oneofKind === 'withdrawal' &&
                                            cardInfo.card.transaction.metadata?.uniqueField.withdrawal.hash && (
                                                <h1>
                                                    Hash:{' '}
                                                    <span>
                                                        {cardInfo.card.transaction.metadata?.uniqueField.oneofKind ===
                                                            'withdrawal' &&
                                                            `${cardInfo.card.transaction.metadata?.uniqueField.withdrawal.hash.slice(
                                                                0,
                                                                5
                                                            )}...${cardInfo.card.transaction.metadata?.uniqueField.withdrawal.hash.slice(
                                                                -5
                                                            )}`}
                                                    </span>
                                                </h1>
                                            )}
                                    </div>
                                </>
                            )}

                            {!!cardInfo.needReviewCardIds.length &&
                                cardInfo.card &&
                                !cardInfo.needReviewCardIds.includes(cardInfo.card?.id) &&
                                !cardInfo.card.reviewApproved &&
                                Math.round(
                                    Number(
                                        (100 * Number(cardInfo.pointsBalanceAvailable)) /
                                            Number(cardInfo.card?.pointsNeeded)
                                    )
                                ) >= 100 && (
                                    <>
                                        <div
                                            style={{ margin: '18px 0' }}
                                            className="l2"></div>
                                        <MessageStick
                                            icon={errorIcon}
                                            title="Загрузите видео отзыв с предыдущим подарком, чтобы забрать новый"
                                            bg="rgba(255, 78, 99, 0.05)"
                                        />
                                    </>
                                )}

                            {cardInfo.card?.transaction?.statusId === Status_Transaction.SUCCESS &&
                                cardInfo.card.transaction.metadata?.uniqueField.oneofKind === 'withdrawal' && (
                                    <div style={{ marginTop: '18px' }}>
                                        <MenuItem
                                            title="Посмотреть транзакцию"
                                            onCLick={() => {
                                                cardInfo.card?.transaction?.statusId === Status_Transaction.SUCCESS &&
                                                    cardInfo.card?.transaction?.metadata?.uniqueField.oneofKind ===
                                                        'withdrawal' &&
                                                    window?.Telegram?.WebApp.openLink(
                                                        `https://bscscan.com/tx/${cardInfo.card?.transaction?.metadata?.uniqueField.withdrawal?.hash}`
                                                    );
                                            }}
                                        />
                                    </div>
                                )}

                            {cardInfo.card?.reviewApproved && cardInfo.card.reviewVideoUrl && (
                                <>
                                    <div
                                        style={{ margin: '18px 0' }}
                                        className="l2"></div>

                                    <MenuItem
                                        title="Посмотреть отзыв"
                                        onCLick={() => window.Telegram.WebApp.openLink(cardInfo.card?.reviewVideoUrl)}
                                    />
                                </>
                            )}

                            {done() ? (
                                <ShodawButton
                                    bg="linear-gradient(180deg, rgba(24, 26, 34, 0) 0%, #181A22 35.45%)"
                                    onClick={() =>
                                        cardInfo.needReviewCardIds.length === 0 &&
                                        navigate(`/buy-card/${cardInfo.card?.id}`)
                                    }
                                    style={{ opacity: cardInfo.needReviewCardIds.length ? 0.5 : 1 }}
                                    icon={prizeWhite}
                                    title={t('get_prize')}
                                />
                            ) : wait() ? (
                                <ShodawButton
                                    bg="linear-gradient(180deg, rgba(24, 26, 34, 0) 0%, #181A22 35.45%)"
                                    onClick={() => window.Telegram.WebApp.openTelegramLink('https://t.me/TTM_HelpBot')}
                                    style={{ background: 'rgba(255, 255, 255, 0.08)', boxShadow: 'none' }}
                                    icon={home}
                                    title={t('menu.help')}
                                />
                            ) : rew() ? (
                                <ShodawButton
                                    bg="linear-gradient(180deg, rgba(24, 26, 34, 0) 0%, #181A22 35.45%)"
                                    onClick={() => cardInfo.card && navigate(`/review/${cardInfo.card.id}`)}
                                    icon={camW}
                                    title={t('rew')}
                                />
                            ) : a() ? (
                                <ShodawButton
                                    bg="linear-gradient(180deg, rgba(24, 26, 34, 0) 0%, #181A22 35.45%)"
                                    style={{ background: 'rgba(47, 248, 127, 0.15)', boxShadow: 'none' }}
                                    icon={checkW}
                                    title={t('getedPresent')}
                                />
                            ) : (
                                <div className={styles.progress}>
                                    <p>
                                        {Math.round(
                                            Number(
                                                (100 * Number(cardInfo.pointsBalanceAvailable)) /
                                                    Number(cardInfo.card?.pointsNeeded)
                                            )
                                        ) > 100
                                            ? 100
                                            : Math.round(
                                                  Number(
                                                      (100 * Number(cardInfo.pointsBalanceAvailable)) /
                                                          Number(cardInfo.card?.pointsNeeded)
                                                  )
                                              )}
                                        %
                                    </p>
                                    <div
                                        className={styles.marker}
                                        style={{
                                            width: `${
                                                Math.round(
                                                    Number(
                                                        (100 * Number(cardInfo.pointsBalanceAvailable)) /
                                                            Number(cardInfo.card?.pointsNeeded)
                                                    )
                                                ) > 100
                                                    ? 100
                                                    : Math.round(
                                                          Number(
                                                              (100 * Number(cardInfo.pointsBalanceAvailable)) /
                                                                  Number(cardInfo.card?.pointsNeeded)
                                                          )
                                                      )
                                            }%`,
                                        }}></div>
                                </div>
                            )}
                        </>
                    </div>
                )}
                {/* {!cardInfo && <Loader fullScreen />} */}
            </div>
        </>
    );
};

export default CardFromMarket;
